import { render, staticRenderFns } from "./CJsonLogicDiscounts.vue?vue&type=template&id=8b4fb820"
import script from "./CJsonLogicDiscounts.vue?vue&type=script&lang=js"
export * from "./CJsonLogicDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports